module.exports = __webpack_public_path__ + "media/components/country-flag/static/mu-e288c2f47395592a69bee931a750b614.svg";